import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { cloneElement, Fragment, useMemo } from 'react';
import { propArrayShape, propStr, propChildren, propFunc, propOneOf, } from '../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../helpers/use/useHook';
import ProfessionalUnitItemsListMoreButton from './ProfessionalUnitItemsListMoreButton';
import ProfessionalUnitItemsListMoreCircle from './ProfessionalUnitItemsListMoreCircle';
const ProfessionalUnitItemsList = (props) => {
    const { className, guestMoreText, items, itemsClassName, moreButtonClassName, moreClassName, renderComponent, showAlertModal, userMode, } = props;
    const { boolState: isShowMore, changeTrue: showMore } = useBoolState(false);
    const isGuest = userMode === 'guest';
    const onClickMore = useMemo(() => {
        switch (userMode) {
            case 'pre':
            case 'other':
                return showAlertModal;
            case 'view':
                return showMore;
            default:
                return undefined;
        }
    }, [userMode, showAlertModal, showMore]);
    const listClassName = useMemo(() => {
        if (isShowMore) {
            return 'is-show-all';
        }
        return clsx(items.length > 0 && 'has-column-1', items.length > 1 && 'has-column-2', items.length > 2 && 'has-column-3', `total-column-${items.length}`);
    }, [items, isShowMore]);
    if (!items.length) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: clsx('unit_items_list', listClassName, className) }, { children: [_jsxs("div", Object.assign({ className: clsx('items_row', itemsClassName) }, { children: [items.map((v, index) => (_jsx(Fragment, { children: cloneElement(renderComponent, {
                            // Truncate要素が非表示だとwarningが出るので回避用に
                            isHiddenAfterSecond: !isShowMore && index > 1,
                            item: v,
                            itemClassName: 'item_column',
                        }) }, v.id))), _jsx(ProfessionalUnitItemsListMoreButton, Object.assign({ className: `${moreButtonClassName} items_list_more_circle_button`, guestText: guestMoreText, onClick: onClickMore, userMode: userMode }, { children: _jsx(ProfessionalUnitItemsListMoreCircle, { isGuest: isGuest }) }))] })), _jsx("div", Object.assign({ className: clsx('more_row', moreClassName) }, { children: _jsx(ProfessionalUnitItemsListMoreButton, Object.assign({ className: `${moreButtonClassName} button items_list_more_button`, guestText: guestMoreText, onClick: onClickMore, userMode: userMode }, { children: isGuest ? guestMoreText : 'すべて見る' })) }))] })));
};
ProfessionalUnitItemsList.propTypes = {
    className: propStr(),
    guestMoreText: propStr().isRequired,
    items: propArrayShape(),
    itemsClassName: propStr(),
    moreButtonClassName: propStr(),
    moreClassName: propStr(),
    renderComponent: propChildren().isRequired,
    showAlertModal: propFunc().isRequired,
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
ProfessionalUnitItemsList.defaultProps = {
    className: '',
    items: [],
    itemsClassName: '',
    moreButtonClassName: '',
    moreClassName: '',
};
export default ProfessionalUnitItemsList;
